import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    permissions: Array,
  },
  mutations: {
    setPermissions (state, payload) {
      state.permissions = payload
    },
  },
  getters: {
    getPermissions: state => {
      return state.permissions
    },
    can: (state) => (value) => {
      if (typeof state.permissions != 'function'){
        if (state.permissions.includes(value)) {
          return true
        }else{
          return false
        }
      }
    },
  },
})
